<app-perfil-shell [showGreeting]="false" [showSecurityBanner]="false" [skipFooterCms]="true" [sectionViewport]="true">
  <div class="solicita-credito">
    <div class="solicita-credito__chrome">
      <h1 class="solicita-credito__title">{{ copy.titulo }}</h1>

      <!-- Mobile: copy del footer arriba (después del header / título) -->
      <div class="solicita-credito__intro">
        <p class="solicita-credito__intro-title">{{ copy.footerTitle }}</p>
        <p class="solicita-credito__intro-subtitle">{{ copy.footerSubtitle }}</p>
      </div>
    </div>

    <div class="solicita-credito__scroll" (scroll)="cerrarAyudasExpress()">
      <form class="solicita-credito__form" [formGroup]="form" (ngSubmit)="onContinuar()">
        <div class="solicita-credito__row">
          <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('monto')">
            <label class="perfil-field__label" for="solicita-monto">{{
              copy.montoLabel
              }}</label>
            <input id="solicita-monto" class="perfil-field__control" type="text" inputmode="numeric" autocomplete="off"
              [placeholder]="copy.montoPlaceholder" formControlName="monto"
              [class.perfil-field__control--invalid]="isInvalid('monto')" (input)="onMontoInput($event)"
              (blur)="onMontoBlur()" placement="top" tooltipClass="stylesToll" container="body"
              [openDelay]="300" [ngbTooltip]="mensajeMontoExpress"
              #montoTooltip="ngbTooltip"
              [disableTooltip]="!mostrarAyudaExpress || !mensajeMontoExpress" />
            @if (isInvalid('monto')) {
            <p class="perfil-field__error">
              {{ errorMessage('monto') }}
            </p>
            }
          </div>

          <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('plazo')">
            <label class="perfil-field__label" for="solicita-plazo">{{
              copy.plazoLabel
              }}</label>
            <input id="solicita-plazo" class="perfil-field__control" type="text" inputmode="numeric" autocomplete="off"
              [placeholder]="copy.plazoPlaceholder" formControlName="plazo"
              [class.perfil-field__control--invalid]="isInvalid('plazo')" (input)="onPlazoInput($event)"
              placement="top" tooltipClass="stylesToll" container="body" [openDelay]="300"
              [ngbTooltip]="mensajePlazoExpress"
              #plazoTooltip="ngbTooltip"
              [disableTooltip]="!mostrarAyudaExpress || !mensajePlazoExpress" />
            @if (isInvalid('plazo')) {
            <p class="perfil-field__error">
              {{ errorMessage('plazo') }}
            </p>
            }
          </div>
        </div>

        <section class="solicita-credito__block" aria-labelledby="tipo-titulo">
          <div class="solicita-credito__block-head">
            <h2 class="solicita-credito__block-title" id="tipo-titulo">
              {{ copy.tipoTitulo }}
              <span class="solicita-credito__required" aria-hidden="true">(*)</span>
            </h2>
            <p class="solicita-credito__block-intro">{{ copy.tipoIntro }}</p>
          </div>

          <div class="solicita-credito__tipo-list" formGroupName="tipoCredito" role="group"
            aria-labelledby="tipo-titulo">
            @for (tipo of tipos; track tipo.id) {
            <label class="solicita-credito__tipo">
              <input class="solicita-credito__check-input" type="checkbox" [formControlName]="tipo.id"
                [attr.aria-describedby]="'tipo-desc-' + tipo.id" (change)="onTipoToggle(tipo.id)" />
              <span class="solicita-credito__check" aria-hidden="true">
                <img class="solicita-credito__check-icon" src="assets/img/perfil/icon-check.svg" alt="" width="12"
                  height="9" />
              </span>
              <span class="solicita-credito__tipo-text">
                <span class="solicita-credito__tipo-name">{{ tipo.titulo }}</span>
                <span class="solicita-credito__tipo-desc" [id]="'tipo-desc-' + tipo.id">{{ tipo.desc }}</span>
              </span>
            </label>
            }
          </div>
          @if (isInvalid('tipoCredito')) {
          <p class="perfil-field__error">
            {{ copy.validaciones.campoObligatorio }}
          </p>
          }
        </section>

        <section class="solicita-credito__block" aria-labelledby="destino-titulo">
          <div class="solicita-credito__block-head">
            <h2 class="solicita-credito__block-title" id="destino-titulo">
              {{ copy.destinoTitulo }}
              <span class="solicita-credito__required" aria-hidden="true">(*)</span>
            </h2>
            <p class="solicita-credito__block-intro solicita-credito__block-intro--dark">
              {{ copy.destinoIntro }}
            </p>
          </div>

          <div class="solicita-credito__destinos">
            <div class="solicita-credito__destinos-cols" formGroupName="destinos">
              <div class="solicita-credito__destinos-col">
                @for (destino of destinosCol1; track destino.id) {
                <label class="solicita-credito__destino" (click)="onDestinoToggle(destino.id, $event)">
                  <input class="solicita-credito__check-input" type="checkbox" [formControlName]="destino.id" />
                  <span class="solicita-credito__check" aria-hidden="true">
                    <img class="solicita-credito__check-icon" src="assets/img/perfil/icon-check.svg" alt="" width="12"
                      height="9" />
                  </span>
                  <span class="solicita-credito__destino-copy">
                    <span class="solicita-credito__destino-label">{{ destino.label }}</span>
                    @if (destino.tooltip) {
                    <span class="solicita-credito__destino-hint" placement="top" tooltipClass="stylesToll"
                      container="body" [openDelay]="300" [ngbTooltip]="destino.tooltip"
                      [attr.aria-label]="destino.tooltip" (click)="$event.preventDefault(); $event.stopPropagation()">
                      <span class="material-icons solicita-credito__destino-hint-icon"
                        aria-hidden="true">help_outline</span>
                    </span>
                    }
                  </span>
                </label>
                }
              </div>
              <div class="solicita-credito__destinos-col">
                @for (destino of destinosCol2; track destino.id) {
                <label class="solicita-credito__destino" (click)="onDestinoToggle(destino.id, $event)">
                  <input class="solicita-credito__check-input" type="checkbox" [formControlName]="destino.id" />
                  <span class="solicita-credito__check" aria-hidden="true">
                    <img class="solicita-credito__check-icon" src="assets/img/perfil/icon-check.svg" alt="" width="12"
                      height="9" />
                  </span>
                  <span class="solicita-credito__destino-copy">
                    <span class="solicita-credito__destino-label">{{ destino.label }}</span>
                    @if (destino.tooltip) {
                    <span class="solicita-credito__destino-hint" placement="top" tooltipClass="stylesToll"
                      container="body" [openDelay]="300" [ngbTooltip]="destino.tooltip"
                      [attr.aria-label]="destino.tooltip" (click)="$event.preventDefault(); $event.stopPropagation()">
                      <span class="material-icons solicita-credito__destino-hint-icon"
                        aria-hidden="true">help_outline</span>
                    </span>
                    }
                  </span>
                </label>
                }
              </div>
            </div>

            @if (showOtroInput) {
            <div class="solicita-credito__otro">
              <input id="solicita-otro-texto" class="perfil-field__control solicita-credito__otro-input" type="text"
                formControlName="otroTexto" [attr.aria-label]="copy.destinoOtro" [attr.maxlength]="otroTextoMaxLength"
                maxlength="500" [class.perfil-field__control--invalid]="isInvalid('otroTexto')"
                placeholder="Escribe aquí" />
            </div>
            }
          </div>

          @if (form.hasError('destinosRequeridos') && (form.dirty || form.touched)) {
          <p class="perfil-field__error">
            {{ copy.validaciones.destinoRequerido }}
          </p>
          }
          @if (isInvalid('otroTexto')) {
          <p class="perfil-field__error">
            {{ copy.validaciones.otroRequerido }}
          </p>
          }
        </section>
      </form>
    </div>
  </div>

  <app-perfil-section-footer perfilSectionFooter variant="necesidad" [titleOverride]="copy.footerTitle"
    [subtitleOverride]="copy.footerSubtitle" [ctaLabelOverride]="botones.solicitarCredito"
    [continuarDisabled]="continuarDisabled" (continuar)="onContinuar()"></app-perfil-section-footer>
</app-perfil-shell>